import { render } from "./BuildingsView.vue?vue&type=template&id=5094fa8f"
import script from "./BuildingsView.vue?vue&type=script&lang=js"
export * from "./BuildingsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__